import { generateParams } from "utils/urlConversion";
import { api } from "services/api";
import { GetPostArgs, GetPostByIdArgs, PostSlug } from "./typing";
import { transformPostResult } from "./transformers";
import { PostI, PostResult, ReleasePost, StandardPost } from "Post/PostTypes";

const postsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPostById: builder.query<StandardPost | ReleasePost, GetPostByIdArgs>({
      query: (args) => {
        const { id, ...searchParams  } = args;
        return `post/${args.id}` + generateParams(searchParams); 
      },
      transformResponse(result: PostResult, meta, arg) {
        return transformPostResult(result);

      },
    }),

    getAllPosts: builder.query<Array<PostResult>, GetPostArgs>({
      query: (args) => {
        return `/posts/list` + generateParams(args);
      }
    }),

    getAllPublishedPosts: builder.query<Array<PostSlug>, GetPostArgs>({
      query: (args) => {
        return `/posts/list/ids` + generateParams(args);
      }
    })




    // getPostByName: builder.query<PostResult, GetPostByNameArgs>({
    //   query: (args) => {
    //     let url = `post/${args.name}`;
    //     if (args.status) {
    //       url = url.concat(`?status=${args.status}`);
    //     }
    //     return url;
    //   }
    // }),

   
    

  })
});


export const {
  useGetAllPostsQuery,
  useLazyGetAllPostsQuery,
  
  useGetAllPublishedPostsQuery,
  useLazyGetAllPublishedPostsQuery,
  
  useGetPostByIdQuery,
  useLazyGetPostByIdQuery,

 } = postsApi;